import SectionBody from '../components/SectionBody';
import SectionContainer from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';

export default function Faq() {
  return (
    <SectionContainer containerId={'faq'}>
      <SectionTitle title={'q + a'} />
      <SectionBody>
        <p className='section-text tracking-widest font-semibold'>
          What should I wear?
        </p>
        <p className='section-text'>
          We're requesting formal/cocktail attire.{' '}
          <b>Please no stiletto-heeled shoes</b> - heels can get caught in the
          slats of the dock.
        </p>
        <p className='section-text tracking-widest font-semibold'>
          Will it be indoors or outdoors?
        </p>
        <p className='section-text'>
          The ceremony and cocktail hour will be outside on the dock. The
          reception will be inside, but with doors open. If it rains, the
          ceremony and cocktail hour will be moved inside the shipyard building
          instead.
        </p>
        <p className='section-text tracking-widest font-semibold'>
          Will there be events other than the wedding?
        </p>
        <p className='section-text'>
          Yes, please stay tuned as we get closer to the date. We will have a
          gathering on Friday night and possibly a breakfast or lunch gathering
          on Friday and Sunday. There is a lot to do in the Boothbay Region --
          the{' '}
          <a
            href={'https://www.boothbayharbor.com/'}
            target={'_blank'}
            rel={'noreferrer'}
            className='text-blue-400 hover:underline'
          >
            Boothbay Chamber of Commerce's website
          </a>{' '}
          is a great resource!
        </p>
        <p className='section-text tracking-widest font-semibold'>
          Can I bring my children?
        </p>
        <p className='section-text'>
          We respectfully request that the ceremony and reception are adults
          only. We want you to celebrate with us so if this is a problem, please
          let us know and we can arrange childcare with local babysitters.
        </p>
        <p className='section-text tracking-widest font-semibold'>
          Any other questions?
        </p>
        <p className='section-text'>
          Feel free to send me (Robbie) an email at{' '}
          <a className='underline' href='mailto:robbie.chatterton@gmail.com'>
            robbie.chatterton@gmail.com
          </a>
          !
        </p>
      </SectionBody>
    </SectionContainer>
  );
}
